import { useMemo } from 'react';
import { Connection, PublicKey } from '@solana/web3.js';
import { RTD_GAME_PROGRAM_ID } from '../constants';
import { CLUSTER_URL, WS_CLUSTER_URL } from '../../solana-constants';

export function useProgram() {
  const programId = useMemo(() => new PublicKey(RTD_GAME_PROGRAM_ID!), []);

  const connection = useMemo(() => {
    const endpoint = CLUSTER_URL;
    return new Connection(endpoint, { wsEndpoint: WS_CLUSTER_URL });
  }, []);

  return { connection, programId };
}

